import { render, staticRenderFns } from "./GruposSitios.vue?vue&type=template&id=a10fad7c&"
import script from "./GruposSitios.vue?vue&type=script&lang=js&"
export * from "./GruposSitios.vue?vue&type=script&lang=js&"
import style0 from "./GruposSitios.vue?vue&type=style&index=0&id=a10fad7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports